<template>
  <div class="d-flex" id="wrapper" :class="{'toggled':active}">
    <div class="bg-light border-right" id="sidebar-wrapper">
      <div class="sidebar-heading">
        <router-link :to="{name: 'home'}" @click.native="toggle">
          <img height="40" :src="logo" alt="">
        </router-link>
      </div>
      <div class="list-group list-group-flush">
        <router-link v-if="lessonPage && lesson" :to="{name: 'subject',params: {slug:lesson.subject_slug}}"
                     active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action bg-dark">
          <img class="mr-2" src="@img/arrow-back.svg" alt="">
          <img class="mr-2" src="@img/grid.svg" alt="">
          <span class="text-white">Liste des cours</span>
        </router-link>
        <a :href="home_url" class="list-group-item list-group-item-action">
          <i class="ti-home"></i>
          <span>Acceuil</span>
        </a>
        <router-link :to="{name:'home'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <i class="ti-layout-grid4"></i>
          <span>Tableau de bord</span>
        </router-link>
        <router-link :to="{name:'agenda'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <img src="@img/book.svg" alt="book">
          <span>Agenda</span>
        </router-link>
        <router-link :to="{name:'exams'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <img src="@img/license.svg" alt="book">
          <span>Annales</span>
        </router-link>
        <router-link :to="{name:'questions'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <img src="@img/discussion_dark.svg" alt="book">
          <span>Questions - Réponses</span>
        </router-link>
        <router-link :to="{name:'subjects'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <img src="@img/subjects.svg" alt="subjects">
          <span>Matieres</span>
        </router-link>
        <router-link :to="{name:'chat'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <img src="@img/discussion_dark.svg" alt="book">
          <span>Messagerie</span>
        </router-link>
        <router-link :to="{name:'profile'}" active-class="" @click.native="toggle"
                     class="list-group-item list-group-item-action">
          <i class="ti-user"></i>
          <span>Profil</span>
        </router-link>
        <router-link @click.native="toggle" class="list-group-item list-group-item-action" active-class=""
                     :to="{name:'subscriptions'}">
          <i class="ti-package"></i>
          <span>Mes abonnements</span>
        </router-link>
        <router-link @click.native="toggle" class="list-group-item list-group-item-action" active-class=""
                     :to="{name:'payments'}">
          <i class="ti-money"></i>
          <span>Mes Factures</span>
        </router-link>
        <a @click="logout" class="list-group-item list-group-item-action">
          <i class="ti-close"></i>
          <span>Se déconnecter</span>
        </a>
      </div>
    </div>
    <div id="page-content-wrapper">
      <photo-swipe/>
      <div class="main">
        <app-header :sidebar-active="active"></app-header>
        <div class="mainBody">
          <router-view></router-view>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "@/components/LayoutPartials/Header";
import Footer from "@/components/LayoutPartials/Footer";
import {mapGetters} from "vuex";
import PhotoSwipe from "@/components/Questions/PhotoSwipe";

export default {
  name: 'App',
  props: {},
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapGetters(['home_url', 'logo', 'logo_mini']),
    ...mapGetters({'lesson': 'lesson/active'}),
    lessonPage() {
      return this.$route.name === 'lesson'
    }
  },
  components: {
    PhotoSwipe,
    'app-header': Header,
    'app-footer': Footer,
  },
  methods: {
    logout() {
      window.logout()
    },
    toggle() {
      this.active = !this.active
    }
  },
  created() {
    this.$root.$on('toggleSidebar', () => {
      this.toggle()
    })
  }
};
</script>

<style lang="scss" scoped>
.list-group-item.router-link-exact-active {
  background-color: $green !important;
  border: none;
  color: white;
}

.list-group-item {
  background: #f8f9fa;
  cursor: pointer;

  &:hover {
    background: #dae0e5;
  }

  i, img {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
}

</style>
